<template>
  <div class="component_card">
    <div class="header_withdraw">
      <p>{{ $t("msg.authenticate") }}</p>
    </div>

    <div
      style="
        display: flex;
        justify-content: center;
        margin-bottom: 30px;
        flex-direction: column;
      "
    >
      <div class="withdraw_steps_img">
        <img class="blu_balance_img" src="../../../../assets/images/3.png" />
      </div>
      <div
        style="
          width: 100%;
          display: flex;
          justify-content: center;
          font-size: 9px;
        "
      >
        <div style="width: 60%; display: flex; justify-content: center">
          <span style="margin-left: 10px; color: #02b9a4">{{
            $t("msg.step_amount")
          }}</span>
          <span style="margin-left: 25px; color: #02b9a4">{{
            $t("msg.step_recipient")
          }}</span>
          <span style="margin-left: 25px; color: #02b9a4">{{
            $t("msg.step_verification")
          }}</span>
          <span style="margin-left: 20px">{{
            $t("msg.step_authentication")
          }}</span>
        </div>
      </div>
    </div>

    <h1 class="text_lg p0 tal_c">
      <strong class="text_m_blu">{{ $t("msg.authenticate") }}</strong>
    </h1>

    <div class="columns redeem_form mw100" v-if="selectedBlue">
      <div class="column">
        <div class="column">
          <p v-html="$t('msg.info_redeem_step_3')"></p>
        </div>
        <div class="column">
          <p>{{ $t("msg.redeem_pin") }}</p>
          <input
            class="amount_redeem"
            type="text"
            v-model="pin"
            style="width: 100%"
          />
          <p class="text_sm">
            {{ $t("msg.check_your_email_for_pin_redeem") }}
            {{ $t("msg.if_no_email_spam") }}
          </p>
        </div>
        <div class="column">
          <p>{{ $t("msg.redeem_2fa") }}</p>
          <input
            class="amount_redeem"
            type="text"
            v-model="twoFA"
            style="width: 100%"
          />
        </div>

        <div
          class="column"
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <button
            class="btn_redeem_back"
            style="background: #e12d2d; width: 100%"
            @click="cancelRedeem()"
          >
            {{ $t("msg.cancel") }}
          </button>

          <button
            class="btn_redeem"
            style="width: 100%"
            @click="confirmRedeem()"
            :disabled="!pin || !twoFA"
          >
            {{ $t("msg.withdraw") }}
          </button>
        </div>
      </div>
    </div>

    <div class="columns redeem_form mw100" v-else>
      <div class="column">
        <div class="column">
          <p v-html="$t('msg.info_redeem_step_3')"></p>
        </div>
        <div class="column">
          <p>{{ $t("msg.redeem_pin") }}</p>
          <input
            class="amount_redeem"
            type="text"
            v-model="pin"
            style="width: 100%"
          />
          <p class="text_sm">
            {{ $t("msg.check_your_email_for_pin_redeem") }}
            {{ $t("msg.if_no_email_spam") }}
          </p>
        </div>
        <div class="column">
          <p>{{ $t("msg.redeem_2fa") }}</p>
          <input
            class="amount_redeem"
            type="text"
            v-model="twoFA"
            style="width: 100%"
          />
        </div>

        <div
          class="column"
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <button
            class="btn_redeem_back"
            style="background: #e12d2d; width: 100%"
            @click="cancelRedeem()"
          >
            {{ $t("msg.cancel") }}
          </button>

          <button
            class="btn_redeem"
            style="width: 100%"
            @click="confirmRedeem()"
            :disabled="!pin || !twoFA"
          >
            {{ $t("msg.withdraw") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  props: ["withdrawData", "selectedBlue", "address"],
  created() {
    if (!this.selectedBlue) {
      this.pinGenerate(this.address);
    }
  },
  mounted() {},
  data: () => ({
    pin: "",
    twoFA: "",
  }),
  components: {},
  methods: {
    async confirmRedeem() {
      if (this.selectedBlue) {
        let withdraw = {
          e2faCode: this.twoFA,
          id: this.withdrawData.id,
          pinCode: this.pin,
        };
        this.loading = true;
        this.$emit("confirmWithdraw", withdraw);
      } else {
        let payload = {
          e2faCode: this.twoFA,
          pinCode: this.pin,
        };

        await this.$store
          .dispatch("postPinGenerate", payload)
          .then((response) => {
            if(response.status == 200){
              this.$emit("callWithdrawUsdt");
            }
          })
          .catch((e) => {
            let err = e.message;
            let text;
            if(err == 'Invalid pin hash'){
              text = this.$t("msg.invalid_pin")
            }

            if(err == 'Invalid 2FA code'){
              text = this.$t("msg.invalid_2fa_code")
            }

            Swal.fire({
              icon: "error",
              title: this.$t("msg.error"),
              text: text,
            });
          });
      }
    },

    async pinGenerate(el) {
      let resp = await this.$store.dispatch("getPinGenerate", el);
      if (resp.status == 200) {
        this.notifySuccess(
          this.$t("msg.check_your_email_for_pin_redeem"),
          5000
        );
      }
    },

    cancelRedeem() {
      this.$emit("cancelRedeem");
    },
  },
  computed: {
    ...mapGetters([]),
  },
  watch: {
    pin: function () {
      this.loading = false;
    },
    twoFA: function () {
      this.loading = false;
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/private/services/withdraw_steps/WithdrawStep3.vue